// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
}
.main_Apply_leaveForm {
  height: auto;

  background-color: white;

  opacity: 100%;
  background: transparent;
}

.center_LeaveForm {
  background-image: linear-gradient(rgb(248, 248, 248), rgb(225, 240, 222));
  border: 1px solid rgb(132, 184, 192);
  border-radius: 20px;

  height: auto;

  width: 475px;

  margin-top: 10px;

  padding: 30px;
}

.heading_ApplyForm {
  height: 50px;
  width: 100%;
  /* margin-left: 30px; */
  margin-top: 10px;
}
.form_Input {
  width: 360px;

  margin-left: 30px;

  display: flex;
  flex-direction: column;
}
.form_Input input {
  border-radius: 12px;
  border: none;

  width: 100%;
  margin-bottom: 16px;
  padding: 13px;
}
.form_Input select {
  border-radius: 12px;
  border: none;
  width: 94%;
  margin-bottom: 16px;
  padding: 12px;
  font-size: 12px;
  color: #4b4a4a;
}
.leaveType {
  border-radius: 12px;
  border: none;
  width: 94%;
  margin-bottom: 16px;
  padding: 13px;
  /* -webkit-appearance: none; */
}

.leaveiconarrow {
  color: #84c7ae;
  font-size: 13px;
  top: 16px;
  position: relative;
  z-index: 1;
  margin-left: -30px;
  font-weight: 700;
  height: 24px;
}

.leaveType::-webkit-calendar-picker-indicator {
  display: none;
}
.form_Input input[type="text"]:focus {
  outline: none;
  border-color: rgb(47, 47, 48);
  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);
}
.form_Input input[type="text"] {
  border: none;
  border-radius: 12px;
  padding: 14px;
}
.form_Input input[type="number"]:focus {
  outline: none;
  border-color: rgb(47, 47, 48);
  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);
}
.form_Input input[type="date"]:focus {
  outline: none;
  border-color: rgb(47, 47, 48);
  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);
}
.leave_text_area:focus {
  outline: none;
  border-color: rgb(47, 47, 48);
  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);
}
.date_Section {
  display: flex;
  width: 100%;
  gap: 16px;
}

.apply_leave  {
  display: flex;
   justify-content: center;
  align-items: center;
  margin-top: 5px;
}
.hr{
display : flex;
margin-top: 8px;
  justify-content: center;
  align-items: center;
}
.btn_Submit button {
  background-color: rgb(132, 199, 174);
  color: white;
  font-size: 18px;
  padding: 10px;
  width: 100px;
  height: 40px;
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  
}
.btn_Submit button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.btn_Submit button.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.spinner {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
::placeholder {
  color: rgb(43, 42, 42);

  padding: 9px;
}
.btn_Submit button:hover:not(:disabled) {
  background-color: rgb(120, 182, 158);
}
.leave_text_area {
  border-radius: 12px;
  border: none;
  height: 70px;
  width: 100%;
  box-sizing: border-box;
  line-height: 1.5rem;

  /* / font-weight: 10px; / */
}
.leave_text_area::placeholder {
  color: rgb(45, 44, 44);
  padding-top: 20px;
  padding-left: 20px;
}

#text {
  padding-left: 10px;
}
@media screen and (max-width: 767px) {
  /* The main wrapper should take full width */
  .main_Apply_leaveForm {
    width: 100%;
    padding: 16px;
  }
  .heading_ApplyForm {
    height: 42px;
    width: 200px;
    margin-left: 30px;
    margin-top: 0px;
  }

  /* Make the form container fluid and centered */
  .center_LeaveForm {
    width: 87vw; /* Use viewport width for responsiveness */
    padding: 14px;
    margin: 10px auto; /* Center the form */
  }

  .heading_ApplyForm {
    margin-left: 0;
    width: 100%;
  }

  .form_Input {
    width: 100%;
    margin-left: 0;
  }

  /* Ensure form elements use the full available width */
  .date_Section {
    width: 100%;
    margin-bottom: -10px;
  }
  .date_Section select {
    background-color: white;
  }
  .leave_text_area {
    width: 100%;
    box-sizing: border-box; /* Ensure padding is included in width */
  }

  /* Align submit button to the right using auto margin */
  .btn_Submit {
    margin-left: auto;
    margin-right: 0; /* Ensure no extra right margin */
    /* margin-top: 15px; */
    width: 100%;
  }
  .btn_Submit button {
    width: 100%;
  }
  .form_Input select {
    border-radius: 10px;

    padding: 13px;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Request/ApplyRequests/ApplyLeaveForm/ApplyLeaveForm.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;AACA;EACE,YAAY;;EAEZ,uBAAuB;;EAEvB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yEAAyE;EACzE,oCAAoC;EACpC,mBAAmB;;EAEnB,YAAY;;EAEZ,YAAY;;EAEZ,gBAAgB;;EAEhB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;;EAEZ,iBAAiB;;EAEjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,YAAY;;EAEZ,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;GACZ,uBAAuB;EACxB,mBAAmB;EACnB,eAAe;AACjB;AACA;AACA,cAAc;AACd,eAAe;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;;AAEjB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,kCAAkC;AACpC;AACA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;AACA;EACE,sBAAsB;;EAEtB,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;;EAEnB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,4CAA4C;EAC5C;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA,+CAA+C;EAC/C;IACE,WAAW,EAAE,0CAA0C;IACvD,aAAa;IACb,iBAAiB,EAAE,oBAAoB;EACzC;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA,sDAAsD;EACtD;IACE,WAAW;IACX,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,sBAAsB,EAAE,wCAAwC;EAClE;;EAEA,uDAAuD;EACvD;IACE,iBAAiB;IACjB,eAAe,EAAE,iCAAiC;IAClD,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;;IAEnB,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":["* {\n  margin: 0;\n}\n.main_Apply_leaveForm {\n  height: auto;\n\n  background-color: white;\n\n  opacity: 100%;\n  background: transparent;\n}\n\n.center_LeaveForm {\n  background-image: linear-gradient(rgb(248, 248, 248), rgb(225, 240, 222));\n  border: 1px solid rgb(132, 184, 192);\n  border-radius: 20px;\n\n  height: auto;\n\n  width: 475px;\n\n  margin-top: 10px;\n\n  padding: 30px;\n}\n\n.heading_ApplyForm {\n  height: 50px;\n  width: 100%;\n  /* margin-left: 30px; */\n  margin-top: 10px;\n}\n.form_Input {\n  width: 360px;\n\n  margin-left: 30px;\n\n  display: flex;\n  flex-direction: column;\n}\n.form_Input input {\n  border-radius: 12px;\n  border: none;\n\n  width: 100%;\n  margin-bottom: 16px;\n  padding: 13px;\n}\n.form_Input select {\n  border-radius: 12px;\n  border: none;\n  width: 94%;\n  margin-bottom: 16px;\n  padding: 12px;\n  font-size: 12px;\n  color: #4b4a4a;\n}\n.leaveType {\n  border-radius: 12px;\n  border: none;\n  width: 94%;\n  margin-bottom: 16px;\n  padding: 13px;\n  /* -webkit-appearance: none; */\n}\n\n.leaveiconarrow {\n  color: #84c7ae;\n  font-size: 13px;\n  top: 16px;\n  position: relative;\n  z-index: 1;\n  margin-left: -30px;\n  font-weight: 700;\n  height: 24px;\n}\n\n.leaveType::-webkit-calendar-picker-indicator {\n  display: none;\n}\n.form_Input input[type=\"text\"]:focus {\n  outline: none;\n  border-color: rgb(47, 47, 48);\n  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);\n}\n.form_Input input[type=\"text\"] {\n  border: none;\n  border-radius: 12px;\n  padding: 14px;\n}\n.form_Input input[type=\"number\"]:focus {\n  outline: none;\n  border-color: rgb(47, 47, 48);\n  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);\n}\n.form_Input input[type=\"date\"]:focus {\n  outline: none;\n  border-color: rgb(47, 47, 48);\n  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);\n}\n.leave_text_area:focus {\n  outline: none;\n  border-color: rgb(47, 47, 48);\n  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);\n}\n.date_Section {\n  display: flex;\n  width: 100%;\n  gap: 16px;\n}\n\n.apply_leave  {\n  display: flex;\n   justify-content: center;\n  align-items: center;\n  margin-top: 5px;\n}\n.hr{\ndisplay : flex;\nmargin-top: 8px;\n  justify-content: center;\n  align-items: center;\n}\n.btn_Submit button {\n  background-color: rgb(132, 199, 174);\n  color: white;\n  font-size: 18px;\n  padding: 10px;\n  width: 100px;\n  height: 40px;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 5px;\n  cursor: pointer;\n  \n}\n.btn_Submit button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.btn_Submit button.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n.spinner {\n  animation: spin 1s linear infinite;\n}\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n::placeholder {\n  color: rgb(43, 42, 42);\n\n  padding: 9px;\n}\n.btn_Submit button:hover:not(:disabled) {\n  background-color: rgb(120, 182, 158);\n}\n.leave_text_area {\n  border-radius: 12px;\n  border: none;\n  height: 70px;\n  width: 100%;\n  box-sizing: border-box;\n  line-height: 1.5rem;\n\n  /* / font-weight: 10px; / */\n}\n.leave_text_area::placeholder {\n  color: rgb(45, 44, 44);\n  padding-top: 20px;\n  padding-left: 20px;\n}\n\n#text {\n  padding-left: 10px;\n}\n@media screen and (max-width: 767px) {\n  /* The main wrapper should take full width */\n  .main_Apply_leaveForm {\n    width: 100%;\n    padding: 16px;\n  }\n  .heading_ApplyForm {\n    height: 42px;\n    width: 200px;\n    margin-left: 30px;\n    margin-top: 0px;\n  }\n\n  /* Make the form container fluid and centered */\n  .center_LeaveForm {\n    width: 87vw; /* Use viewport width for responsiveness */\n    padding: 14px;\n    margin: 10px auto; /* Center the form */\n  }\n\n  .heading_ApplyForm {\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .form_Input {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  /* Ensure form elements use the full available width */\n  .date_Section {\n    width: 100%;\n    margin-bottom: -10px;\n  }\n  .date_Section select {\n    background-color: white;\n  }\n  .leave_text_area {\n    width: 100%;\n    box-sizing: border-box; /* Ensure padding is included in width */\n  }\n\n  /* Align submit button to the right using auto margin */\n  .btn_Submit {\n    margin-left: auto;\n    margin-right: 0; /* Ensure no extra right margin */\n    /* margin-top: 15px; */\n    width: 100%;\n  }\n  .btn_Submit button {\n    width: 100%;\n  }\n  .form_Input select {\n    border-radius: 10px;\n\n    padding: 13px;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
